import { Box, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import { useSystemChrome } from '@/designs-dev/device/SystemChromeContext';

// iPhone-style status bar (47px top safe area) shared across app screens.
// Renders nothing where the screen is not a phone — a desktop window has its own
// clock and battery, and drawing a second set inside the design is a lie about
// what the design is.
const StatusBar = () => {
  if (!useSystemChrome()) return null;

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 47,
        px: 3,
        flexShrink: 0,
      }}
      direction='row'
    >
      <Typography variant='body2'>9:41</Typography>
      <Stack sx={{ alignItems: 'center' }} direction='row' spacing={0.75}>
        <Icon icon={'signal-bars' as never} fontSize={13} />
        <Icon icon={'wifi' as never} fontSize={13} />
        <Box
          sx={{
            width: 22,
            height: 11,
            border: 1,
            borderColor: 'text.primary',
            borderRadius: '3px',
            display: 'flex',
            alignItems: 'center',
            p: '1px',
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              width: '70%',
              height: '100%',
              bgcolor: 'text.primary',
              borderRadius: '1px',
            }}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default StatusBar;
